/**
 * Simple clearfix
 */
export const clearFix = `
  &::after{
    content: '';
    display: block;
    clear: both;
  }
`;
